import React from "react";
import { Button, Dropdown, MenuProps } from "antd";
import { AppIcon } from "./SVGFiles";
import { AppContext, setAnnouncements, setAppLink, setSelectedAnncmnt } from "../context";
import { AppAnnouncement } from "./AppAnnouncement";
import { getAnnouncement } from "../remote";

const APP_CONTAINER = document.getElementById("SS-DashboardWrapper");
export const UserTopNav: React.FC = () => {
    const { state, dispatch } = React.useContext(AppContext);
    const { user, formLinks } = state;
    const [announceLoaded, setAnnounceLoaded] = React.useState(true);
    const { firstName, lastName, companyNo } = user || {};

    React.useEffect(() => {
        const apiUrl = APP_CONTAINER?.dataset.announcement || APP_CONTAINER?.getAttribute("data-announcement");
        if (apiUrl) {
            getAnnouncement()
                .then((data) => {
                    if (data.Announcements.length > 0) {
                        dispatch(setAnnouncements(data.Announcements));
                    }
                    dispatch(setSelectedAnncmnt(data.Announcements[0]));
                    dispatch(setAppLink(data.MobileAppLinks));
                })
                .catch((err) => {
                    dispatch(setAnnouncements(null));
                })
                .finally(() => setAnnounceLoaded(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const items: MenuProps["items"] = formLinks
        ? formLinks
              .filter((nav) => nav.enabled)
              .map((navProps, i) => {
                  return {
                      key: `${i}`,
                      label: (
                          <a role={"button"} href={navProps.link}>
                              <span>{navProps.label}</span>
                          </a>
                      ),
                      icon: <AppIcon asset={navProps.icon} stroke="#000000" height="16" width="16" />,
                  };
              })
              .concat({
                  key: "logout",
                  label: (
                      <a role={"button"} href={process.env.REACT_APP_LOGOUT_URL as string}>
                          <span>Logout</span>
                      </a>
                  ),
                  icon: <AppIcon asset={"logout"} stroke="#000000" height="16" width="16" />,
              })
        : [];

    const employeeName = React.useMemo(() => {
        if (user) {
            return <span className="f-bold">{[firstName, lastName].join(" ")}</span>;
        }
        return "";
    }, [user, firstName, lastName]);

    const hasAppLink = false; // state.announcements !== null;
    return (
        <div className={`ss-dashboard-wrap-user-top-nav d-flex flex-acenter${hasAppLink ? " has-app-link" : ""}`}>
            <span className="ss-dashboard-wrap-user-name d-flex flex-acenter">
                <span className="ss-dashboard-wrap-mobile-name d-flex flex-acenter">{employeeName}</span>
                {user ? (
                    <span className="ss-dashboard-wrap-company-number">
                        <span className="c-gray3">Company Number: {companyNo}</span>
                        <span className="m-l-12 m-r-8 c-gray4">|</span>
                    </span>
                ) : null}
                <Dropdown menu={{ items }} trigger={["click"]} arrow placement="bottomRight" overlayClassName="ss-dashboard-wrap-profile-overlay">
                    <span className="ss-dashboard-wrap-user-dd">
                        {/* {employeeAcro} */}
                        <span className="m-r-8">{employeeName}</span>
                        <AppIcon asset="arrow-down" stroke="#636E7C" height="16" width="16" />
                    </span>
                </Dropdown>
            </span>

            {hasAppLink && <AppAnnouncement loading={announceLoaded} />}

            <Button
                className="help-btn"
                type="link"
                shape="circle"
                icon={<AppIcon asset="help" height="30" width="30" />}
                onClick={() => window.open(process.env.REACT_APP_HELP_URL as string, "_blank")}
            />
        </div>
    );
};
